export const getLocalDateFromDateTime = date => {
  const addZero = num => num.toString().padStart(2, '0');
  return `${date.getFullYear()}-${addZero(date.getMonth() + 1)}-${addZero(date.getDate())}`;
};

// example - return 2020-10-05T00:00:00
export const getLocalDateTimeStartOfDay = date => {
  const localDate = getLocalDateFromDateTime(date);
  return `${localDate}T00:00:00`;
};
export const getEndOfDayFromLocalDate = localDate => `${localDate}T23:59:59`;

// example - return 2020-10-05T23:59:59
export const getLocalDateTimeEndOfDay = date => {
  const localDate = getLocalDateFromDateTime(date);
  return getEndOfDayFromLocalDate(localDate);
};
//# sourceMappingURL=index.js.map